import { CheckmarkFilledIcon } from '../../system-icons/CheckmarkFilledIcon.js';
import { ErrorFilledIcon } from '../../system-icons/ErrorFilledIcon.js';
import { InfoFilledIcon } from '../../system-icons/InfoFilledIcon.js';
import { WarningFilledIcon } from '../../system-icons/WarningFilledIcon.js';

var getStatusIcon = function getStatusIcon(status) {
  switch (status) {
    case 'critical':
      return ErrorFilledIcon;
    case 'danger':
      return ErrorFilledIcon;
    case 'success':
      return CheckmarkFilledIcon;
    case 'warning':
      return WarningFilledIcon;
    case 'neutral':
      return InfoFilledIcon;
    default:
      return null;
  }
};

export { getStatusIcon };
